<div class="container">
    <h1> 404 Not Found</h1>
    <p> The page you tried to access is not exist</p>
</div>